import { createSlice } from "@reduxjs/toolkit";

const CQASlice = createSlice({
  name: "CQA",
  initialState: {
    CQA: {
      data: [],
      loading: false,
      error: null,
    },
    cqaStaff: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    addCQAStart(state) {
        state.CQA.loading = true;
        state.CQA.error = null;
    },
    addCQASuccess(state, action) {
        state.CQA.loading = false;
        state.CQA.data = action.payload;
    },
    addCQAFailure(state, action) {
        state.CQA.loading = false;
        state.CQA.error = action.payload;
    },   
    updateCQAStart(state) {
        state.CQA.loading = true;
        state.CQA.error = null;
    },
    updateCQASuccess(state, action) {
        state.CQA.loading = false;
        state.CQA.data = action.payload;
    },
    updateCQAFailure(state, action) {
        state.CQA.loading = false;
        state.CQA.error = action.payload;
    },   
    fetchCQAStart(state) {
        state.CQA.loading = true;
        state.CQA.error = null;
    },
    fetchCQASuccess(state, action) {
        state.CQA.loading = false;
        state.CQA.data = action.payload;
    },
    fetchCQAFailure(state, action) {
        state.CQA.loading = false;
        state.CQA.error = action.payload;
    },   
    deleteCQAStart(state) {
      state.CQA.loading = true;
      state.CQA.error = null;
  },
  deleteCQASuccess(state, action) {
      state.CQA.loading = false;
      state.CQA.data = action.payload;
  },
  deleteCQAFailure(state, action) {
      state.CQA.loading = false;
      state.CQA.error = action.payload;
  },   
  fetchCQADescriptionStart(state) {
    state.CQA.loading = true;
        state.CQA.error = null;
    },
  fetchCQADescriptionSuccess(state, action) {
        state.CQA.loading = false;
        state.CQA.data = action.payload;
    },
    fetchCQADescriptionFailure(state, action) {
        state.CQA.loading = false;
        state.CQA.error = action.payload;
    },
    updateCQADescriptionStart(state) {
        state.CQA.loading = true;
            state.CQA.error = null;
        },
      updateCQADescriptionSuccess(state, action) {
            state.CQA.loading = false;
            state.CQA.data = action.payload;
        },
        updateCQADescriptionFailure(state, action) {
            state.CQA.loading = false;
            state.CQA.error = action.payload;
        },
    fetchCqaStaffStart(state) {
      state.cqaStaff.loading = true;
      state.cqaStaff.error = null;
    },
    fetchCqaStaffSuccess(state, action) {
      state.cqaStaff.loading = false;
      state.cqaStaff.data = action.payload;
    },
    fetchCqaStaffFailure(state, action) {
      state.cqaStaff.loading = false;
      state.cqaStaff.error = action.payload;
    },
    addCqaStaffStart(state) {
      state.cqaStaff.loading = true;
      state.cqaStaff.error = null;
    },
    addCqaStaffSuccess(state) {
      state.cqaStaff.loading = false;
    },
    addCqaStaffFailure(state, action) {
      state.cqaStaff.loading = false;
      state.cqaStaff.error = action.payload;
    },
    deleteCqaStaffStart(state) {
      state.cqaStaff.loading = true;
      state.cqaStaff.error = null;
    },
    deleteCqaStaffSuccess(state, action) {
      state.cqaStaff.loading = false;
      state.cqaStaff.data = state.cqaStaff.data.filter((s) => s.id !== action.payload);
    },
    deleteCqaStaffFailure(state, action) {
      state.cqaStaff.loading = false;
      state.cqaStaff.error = action.payload;
    },
    updateCqaStaffStart(state) {
      state.cqaStaff.loading = true;
      state.cqaStaff.error = null;
    },
    updateCqaStaffSuccess(state) {
      state.cqaStaff.loading = false;
    },
    updateCqaStaffFailure(state, action) {
      state.cqaStaff.loading = false;
      state.cqaStaff.error = action.payload;
    },
  },
});
export const {
  updateCQAStart,
  updateCQASuccess,
  updateCQAFailure,
  fetchCQAStart,
  fetchCQASuccess,
  fetchCQAFailure,
  addCQAStart,
  addCQASuccess,
  addCQAFailure,
  deleteCQAStart,
  deleteCQASuccess,
  deleteCQAFailure,
  fetchCQADescriptionStart,
  fetchCQADescriptionSuccess,
  fetchCQADescriptionFailure,
  updateCQADescriptionStart,
  updateCQADescriptionSuccess,
  updateCQADescriptionFailure,
  fetchCqaStaffStart,
  fetchCqaStaffSuccess,
  fetchCqaStaffFailure,
  addCqaStaffStart,
  addCqaStaffSuccess,
  addCqaStaffFailure,
  deleteCqaStaffStart,
  deleteCqaStaffSuccess,
  deleteCqaStaffFailure,
  updateCqaStaffStart,
  updateCqaStaffSuccess,
  updateCqaStaffFailure,
}= CQASlice.actions;

export default CQASlice.reducer;
